import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {ZoneFilters} from "../../services/ngage/zones";

export default function useGetZones(
  criteria: ZoneFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['zones', criteria],
    () => ngage.zones.filtered(criteria),
    {enabled, keepPreviousData}
  );
}